import React from 'react';
import PropTypes from 'prop-types';

const StaticTextInput = ({ fieldName, fieldSize, value }) => (
  <div
    className={`FormInput FormInput--static FormInput--size-${fieldSize} FormInput--${fieldName}`}
  >
    {value}
  </div>
);

StaticTextInput.propTypes = {
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.node,
  fieldSize: PropTypes.func.isRequired,
};

export default StaticTextInput;
